// extracted by mini-css-extract-plugin
export default {"readonly":"common_readonly__qExJ1","noTouchCallout":"common_noTouchCallout__Y3cn7","noSelect":"common_noSelect__k4SJD","button":"common_button__oKHGZ"};